import {
  GroupTransportFilter,
  useTransportGroupData,
} from "components/Common/GroupTransportSelect";
import HubFilter from "components/shared-components/RemoteTable/HubFilter/HubFilter";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import {
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalHeader,
  Row,
} from "reactstrap";
import { Switch } from "antd";
import { Label } from "reactstrap";
import BreadcrumbWithLink from "../../components/Common/BreadcrumbWithLink";
import ConfirmModal from "../../components/shared-components/ConfirmModal";
import RemoteDataTable from "../../components/shared-components/RemoteTable/data-table";
import { useDeleteTransport, useListTransport } from "../../hooks";
import TransportForm from "./TransportForm";
import { getInitTransportParams, getLabelShipingTypeByValue } from "./utils";

const ListTransport = () => {
  const { t } = useTranslation(["transport"]);
  const { getGroupTransportOption, optionsSelect } = useTransportGroupData();
  // const [is_level_2, setIsLevel2] = useState(true);

  const initColumns = [
    {
      dataField: "hub_id",
      text: t("table.hub_id"),
      sort: true,
      formatter: (cell, row) => {
        return row?.hub?.name;
      },
    },
    {
      dataField: "group_code",
      text: t("table.group"),
      sort: false,
      formatter: (cell, row) => {
        return getGroupTransportOption(cell, optionsSelect)?.label;
      },
    },
    {
      dataField: "code",
      text: t("table.code"),
      sort: false,
      allowExport: true,
    },
    {
      dataField: "name",
      text: t("table.name"),
      sort: false,
      allowExport: true,
    },
    {
      dataField: "shipping_type",
      text: t("table.type"),
      sort: true,
      allowExport: true,
      formatter: (cell, _row) => {
        return getLabelShipingTypeByValue(t, cell);
      },
    },
  ];

  const [columnsTable, setColumnsTable] = useState([]);
  const [openModalCreate, setOpenModalCreate] = useState(false);
  const [openModalUpdate, setOpenModalUpdate] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [updatingTransport, setUpdatingTransport] = useState(null);
  const [deletingTransport, setDeletingTransport] = useState(null);
  const [transportParams, setTransportParams] = useState(
    getInitTransportParams
  );

  const {
    data: transports,
    isFetching: isLoadingList,
    refetch: fetchTransports,
  } = useListTransport({ params: transportParams });

  useEffect(() => {
    if (transportParams && transportParams?.run) {
      fetchTransports();
    }
  }, [transportParams]);

  // const handleChangeIsLevel2 = newIsLevel2 => {
  //   setIsLevel2(newIsLevel2);
  // };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    setTransportParams(prev => ({
      ...prev,
      sort: sortField ? sortOrder + sortField : transportParams.sort,
      columnFilter:
        {
          ...prev.columnFilterKeep,
          ...columnFilter,
        } || {},
      page: page || 1,
      sizePerPage: sizePerPage || 10,
    }));
  };

  const onChangeGroupTransport = selected => {
    setTransportParams(prev => ({
      ...prev,
      columnFilter: {
        ...prev.columnFilter,
        "filter[group_code]": selected ? selected.value : undefined,
      },
    }));
  };

  const onSearchAllHandle = value => {
    console.log(value);
    setTransportParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const { mutate: deleteTransport } = useDeleteTransport(fetchTransports);
  const handleDelete = () => {
    deleteTransport(deletingTransport.id);
    setOpenModalDelete(false);
  };

  const listRowAction = [
    {
      icon: <i className="fas fa-pen fa-lg text-primary" />,
      text: t("table.actions.update"),
      onClick: row => {
        setUpdatingTransport(row);
        setOpenModalUpdate(true);
      },
    },
    // {
    //   icon: <i className="fas fa-trash fa-lg text-danger" />,
    //   text: t("table.actions.delete"),
    //   onClick: row => {
    //     setDeletingTransport(row);
    //     setOpenModalDelete(true);
    //   },
    // },
  ];

  const toggleModalCreate = value =>
    setOpenModalCreate(prev => (value !== undefined ? value : !prev));
  const toggleModalUpdate = value =>
    setOpenModalUpdate(prev => (value !== undefined ? value : !prev));

  useEffect(() => {
    setColumnsTable(initColumns);
  }, [optionsSelect]);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.list") + ` (${transports?.totalCount || 0})`}
            breadcrumbItems={[
              { name: t("title.transport") },
              { name: t("title.list") },
            ]}
          />
        </div>
        <Modal
          isOpen={openModalUpdate}
          size="lg"
          centered
          toggle={() => toggleModalUpdate()}
        >
          <ModalHeader toggle={() => toggleModalUpdate()}>
            {t("title.update")}
          </ModalHeader>
          <TransportForm
            isOpen={openModalUpdate}
            transport={updatingTransport}
            // is_level_2={is_level_2}
            onSuccess={() => {
              toggleModalUpdate(false);
              fetchTransports();
            }}
          />
        </Modal>
        <Modal
          isOpen={openModalCreate}
          centered
          size="lg"
          toggle={() => toggleModalCreate()}
        >
          <ModalHeader toggle={() => toggleModalCreate()}>
            {t("title.create")}
          </ModalHeader>
          <TransportForm
            isOpen={openModalCreate}
            // is_level_2={is_level_2}
            onSuccess={() => {
              toggleModalCreate(false);
              fetchTransports();
            }}
          />
        </Modal>
        <ConfirmModal
          isOpen={openModalDelete}
          titleHeader={t("action.delete.title")}
          titleBody={`
                        ${t("action.delete.description", {
                          code: deletingTransport?.code,
                        })} ?`}
          onConfirm={handleDelete}
          textBtnConfirm={t("button.confirm")}
          textBtnCancel={t("button.cancel")}
          toggle={() => setOpenModalDelete(false)}
        />
        <Row>
          <Col className="col-12">
            <Card>
              <CardBody>
                <RemoteDataTable
                  // selectRow={selectRowCheckbox}
                  keyField="id"
                  data={transports?.items || []}
                  columns={columnsTable}
                  page={transportParams.page}
                  sizePerPage={transportParams.sizePerPage}
                  totalSize={transports?.totalCount || 0}
                  onTableChange={handleTableChange}
                  onSearchAllHandle={onSearchAllHandle}
                  listRowAction={listRowAction}
                  loading={isLoadingList}
                >
                  <div className="d-flex gap-2 align-items-center">
                    {/* <Label
                      className="d-flex align-items-center gap-1 mb-0"
                      style={{ cursor: "pointer" }}
                      htmlFor="is_level_2"
                      onClick={() => handleChangeIsLevel2(!is_level_2)}
                    >
                      <Switch
                        checked={is_level_2}
                        onChange={handleChangeIsLevel2}
                      />
                      Địa chỉ 2 cấp
                    </Label> */}

                    <HubFilter
                      mainFilterParams={transportParams}
                      setMainFilterParams={setTransportParams}
                      isNotFilterChildHub={true}
                      isHaveAllOption={true}
                      isFilterAllDefault={true}
                      // addressLevel={is_level_2 ? 2 : 3}
                    />
                    <GroupTransportFilter onChange={onChangeGroupTransport} />
                    <Button
                      onClick={() => setOpenModalCreate(true)}
                      color="primary"
                      className="btn-label me-2"
                      type="button"
                    >
                      <i className="fas fa-plus label-icon" />
                      {t("title.create")}
                    </Button>
                  </div>
                </RemoteDataTable>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default ListTransport;
